import PopoutParentStore from './schema/PopoutParentStore';

// This doesn't need to be a mobx store for now since no react component rely on it
let store: PopoutParentStore = {
    popouts: null,
};

export default store;
